import {useTranslation} from "react-i18next";
import {useContext, useEffect, useRef, useState, useMemo} from "react";
// -
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import AuthContext from "context/AuthContext";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "views/utils/buttonsActions";
import axiApi from "ApiCaller";
import navs from "./navs";
import {NetworkConfig} from "site-apps/devices/networks/NetworksConfigsModels";
import TableConfig from "./configs/TableConfig";
//import PreviewConfig from "./configs/PreviewConfig";
import FormConfig from "./configs/FormConfig";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import NoConfigsData from "./configs/NoConfigsData";

const ViewConfigs = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");
    const {user} = useContext(AuthContext);
    document.title = _Tr("labels.config");
    const bread = useMemo(
        () => [
            {
                name: _Tr("labels.advanced"),
                url: "/advanced/",
                current: false,
            },
            {name: document.title, current: true},
        ],
        [_Tr]
    );
    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    const items = useRef(new ItemsModel());
    const params = useRef({
        models: [],
    });
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({...NetworkConfig});
    const [checkedAll, setCheckedAll] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [models, setModels] = useState([]);
    const [servers, setServers] = useState([]);
    const [mqtts, setMqtts] = useState([]);
    const [ntps, setNtps] = useState([]);
    const [gpss, setGPSs] = useState([]);
    const [buttonsTB, setButtonsTB] = useState(new ButtonsActions());
    // data table
    const [itemsShown, setItemsShown] = useState([]);

    const headersTable = [
        {name: _Tt("common.config"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.default"), attr: 1, direction: "asc", active: false},
        {name: _Tt("devices.model"), attr: 2, direction: "asc", active: false},
        {name: _Tt("networks.network"), attr: 3, direction: "asc", active: false},
        {name: "MQTT", attr: 4, direction: "asc", active: false},
        {name: "NTP", attr: 5, direction: "asc", active: false},
        {name: "GPS", attr: 6, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;

        if (user.is_admin) {
            buttons.add.active = true;
            buttons.add.disabled = false;
            buttons.add.onClick = onClickAdd;
            buttons.delete.active = true;
            buttons.delete.onClick = onCLickDelete;
        }
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchData();
        };
        filters.current.filter = () => {
            pagerModelRef.current.paging.page = 1;
            fetchData();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchData();
        items.current.setShowPrev = setShowPreview;
        items.current.item = NetworkConfig;
        items.current.setItem = setItem;
        fetchGetData();
    }, []);

    const fetchGetData = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get(`/api/devices/networks/`);
            pagerModelRef.current.paging.setPager(resp.data);
            if (resp.data) {
                pagerModelRef.current.active = resp.data.items.length > 0;
                items.current.showed = [...resp.data.items];
                items.current.clearChosen();
                setItemsShown([...resp.data.items]);

                setModels([...resp.data.params.models]);
                params.current.models = [...resp.data.params.models];
                setServers([...resp.data.params.servers]);
                setMqtts([...resp.data.params.mqtts]);
                setNtps([...resp.data.params.ntps]);
                setGPSs([...resp.data.params.gpss]);
                setButtonsTB((prev) => {
                    return {
                        ...prev,
                        add: {
                            ...prev.add,
                            disabled: resp.data.params.models.length === 0,
                        },
                    };
                });
            } else {
                console.error("Error en devicesDefaults.api()");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setIsLoading(false);
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post(
                `/api/devices/networks/`,
                filters.current.chosen,
                {
                    params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
                }
            );
            pagerModelRef.current.paging.setPager(resp.data);

            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
            } else {
                console.error("Error en devicesDefaults.api()");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    function onClickAdd() {
        setShowPreview(false);
        let item_ = {...NetworkConfig};
        item_.model = params.current.models[0];
        setItem(item_);
        setShowPreview(true);
    }

    function onCLickDelete() {
        AlertQuestion.fire(
            "Atención",
            `Se borrarán la configuración de selecionada`
        ).then((quest) => {
            if (quest.isConfirmed) {
                deleteItems();
            }
        });
    }

    function deleteItems() {
        let itemsDelete = items.current.getChosenIds();
        axiApi
            .delete(`/api/devices/network/`, {data: {ids: itemsDelete}})
            .then((r) => {
                if (r.data.status) {
                    items.current.showed = items.current.showed.filter(
                        (power) => !itemsDelete.includes(power.id)
                    );
                    setItemsShown([...items.current.showed]);
                    Alert.success(
                        "Operación realizada con éxito",
                        "Los registros seleccionados se han eliminado correctamente"
                    );
                } else {
                    Alert.warning(
                        "Error en el servicio",
                        "No se han podido borrar los datos"
                    );
                }
            })
            .catch((e) => {
                console.error("Error deleting items:", e);
                Alert.error(_Tf("errors.not-permitted"), e.response.data.message);
            })
            .finally(() => {
                const buttons = {...buttonsTB};
                buttons.delete.disabled = true;
                setButtonsTB(buttons);
                items.current.clearChosen();
            });
    }

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination
                pagerModel={pagerModelRef.current}
                stickyTopValue="125px"
                chosen={items.current.chosen}
            />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <NoConfigsData items={itemsShown}>
                            <TableConfig
                                items={items}
                                itemsShow={itemsShown}
                                buttonsTB={buttonsTB}
                                setButtonsTB={setButtonsTB}
                                setItem={setItem}
                                checkAll={checkedAll}
                                setCheckAll={setCheckedAll}
                                setShowPreview={setShowPreview}
                                orderingRef={orderingRef}
                            />
                        </NoConfigsData>
                    </LoaderSpinner>
                </div>
                {showPreview ? (
                    <FormConfig
                        items={items}
                        item={item}
                        isSuperUser={user.is_admin}
                        models={models}
                        servers={servers}
                        mqtts={mqtts}
                        ntps={ntps}
                        gpss={gpss}
                        setItemsShown={setItemsShown}
                        onClickDelete={onCLickDelete}
                        show={showPreview}
                        setShow={setShowPreview}
                    />
                ) : (
                    <> </>
                )}
            </div>
        </>
    );
};
export default ViewConfigs;
